<template>
  <b-modal id="bank-modal" :title="'تفاصيل طلب النشر'" shadow hide-footer :no-close-on-backdrop="true"
    @hidden="clearForm" @show="initialPosition" size="lg" body-class="p-5">
    <VForm v-slot="{ onValidate }">
      <b-row>
        <b-col>
          <p><strong>نوع العملية:</strong> {{ form.action_type }}</p>
        </b-col>
        <b-col>
          <p><strong>المصرف:</strong> {{ form.bank }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p><strong>الصفحة:</strong> {{ form.table_name }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p><strong>تاريخ الطلب:</strong> {{ form.requested_at }}</p>
        </b-col>
        <b-col>
          <p><strong>المستخدم:</strong> {{ form.requested_by }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p><strong>الحالة:</strong> {{ form.status }}</p>
        </b-col>
      </b-row>
      <b-row>
        <hr />
      </b-row>
      <b-row v-if="form.old_value" class="mt-3">
        <b-col>
          <p><strong>القيمة القديمة:</strong></p>
          <div v-for="(value, key) in getFilteredOldValues" :key="key">
            <span style="font-size: 1.2em; color: brown;">{{ translateKey(key) }}:</span> <span>{{ key == 'type' &&
              value == 0 ?
              "اسلامي" : key == 'type' && value == 1 ? "تجاري" : value }}</span>
            <hr />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <hr />
      </b-row>
      <b-row v-if="form.new_value" class="mt-3">
        <b-col>
          <p><strong>القيمة الجديدة:</strong></p>
          <div v-for="(value, key) in getFilteredNewValues" :key="key">
            <span style="font-size: 1.2em; color: brown;">{{ translateKey(key) }}:</span> <span>{{ key == 'type' &&
              value == 0 ?
              "اسلامي" : key == 'type' && value == 1 ? "تجاري" : value }}</span>
            <hr />
          </div>
        </b-col>
      </b-row>
      <b-row class="my-3" v-if="!readonly">
        <b-col>
          <b-button :variant="form.id ? 'success' : 'info'" block @click="onValidate(action)">{{ form.id ? "تحديث" :
            "أضافة" }}</b-button>
        </b-col>
        <b-col>
          <b-button variant="outline-info" block @click="$bvModal.hide('bank-modal')">الغاء</b-button>
        </b-col>
      </b-row>
    </VForm>
  </b-modal>
</template>

<script>
import { clearObject, successAlert, errorAlert } from "@/utils/helper";

export default {
  props: { readonly: Boolean },
  data() {
    return {
      addLocation: true,
      markerOptions: {
        url: require("../../../../assets/marker.png"),
        size: { width: 30, height: 60, f: "px", b: "px" },
        scaledSize: { width: 25, height: 45, f: "px", b: "px" },
      },
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.admin.auditLogs.form;
      },
      set(value) {
        this.$store.commit("admin/auditLogs/SET_BANK", value);
      },
    },
    types() {
      return this.$store.state.admin.auditLogs.types;
    },
    getFilteredOldValues() {
      if (this.form.old_value && this.form.new_value) {
        return Object.keys(this.form.old_value)
          .filter(key => key !== 'id' && key !== 'bank_id' && key !== 'status' && this.form.old_value[key] != this.form.new_value[key])
          .reduce((result, key) => {
            result[key] = this.form.old_value[key];
            return result;
          }, {});
      } else if (this.form.old_value) {
        return Object.keys(this.form.old_value)
          .filter(key => key !== 'id' && key !== 'bank_id' && key !== 'status')
          .reduce((result, key) => {
            result[key] = this.form.old_value[key];
            return result;
          }, {});
      } else {
        return {};
      }
    },
    getFilteredNewValues() {
      if (this.form.new_value && this.form.old_value) {
        return Object.keys(this.form.new_value)
          .filter(key => key !== 'id' && key !== 'bank_id' && key !== 'status' && this.form.new_value[key] != this.form.old_value[key])
          .reduce((result, key) => {
            result[key] = this.form.new_value[key];
            return result;
          }, {});
      } else if (this.form.new_value) {
        return Object.keys(this.form.new_value)
          .filter(key => key !== 'id' && key !== 'bank_id' && key !== 'status')
          .reduce((result, key) => {
            result[key] = this.form.new_value[key];
            return result;
          }, {});
      } else {
        return {};
      }
    }
  },
  methods: {
    translateKey(key) {
      const translations = {
        action_type: "نوع العملية",
        approved_at: "تاريخ الموافقة",
        approved_by: "تمت الموافقة بواسطة",
        bank: "المصرف",
        id: "رقم التعريف",
        lat: "خط العرض",
        lng: "خط الطول",
        new_value: "القيمة الجديدة",
        old_value: "القيمة القديمة",
        record_id: "رقم السجل",
        rejected_at: "تاريخ الرفض",
        rejected_by: "تم الرفض بواسطة",
        requested_at: "تاريخ الطلب",
        requested_by: "تم الطلب بواسطة",
        status: "الحالة",
        table_name: "اسم الجدول",
        phone: "رقم الهاتف",
        email: "البريد الالكتروني",
        address: "العنوان",
        name: "الاسم",
        type: "النوع",
        created_at: "تاريخ الانشاء",
        updated_at: "تاريخ التعديل",
        website: "الموقع الالكتروني",
        logo: "الشعار",
        cover: "الغلاف",
        about: "نبذة عن",
        location: "العنوان",
        image: "الصورة",
        advantages_and_conditions: "المزايا والشروط",
        fees_and_commissions: "الرسوم والعمولات",
        benefit: "الفائدة",
        conditions: "الشروط",
        limits: "الحدود",
        mechanism: "الآلية",
        payment_mechanism: "آلية الدفع",
        period: "الفترة",
        warranties: "الضمانات",
        text: "المحتوى",
        procedures: "الإجراءات",
        legal_framework: "الإطار القانوني",
        documents: "المستندات",
        terms_and_conditions: "الشروط والأحكام",
        governate: "المحافظة",
        district: "المنطقة",
        branch: "الفرع",
        phone: "الهاتف",
        name: "الاسم",
      };
      return translations[key] || key;
    },
    action() {
      var state = this.form.id ? "update" : "store";
      if (!this.addLocation) {
        this.form.lat = 0;
        this.form.lng = 0;
      }
      this.$store
        .dispatch(`admin/auditLogs/${state}`)
        .then((response) => {
          successAlert();
          this.$bvModal.hide("bank-modal");
          this.$store.commit(
            `admin/auditLogs/${state.toUpperCase()}_BANK`,
            response.payload
          );
          // this.$store.dispatch("admin/banks/get", this.page);
        })
        .catch((error) =>
          errorAlert(
            error.response ? error.response.data.message : "حدثت مشكله"
          )
        );
    },
    setLocation(data) {
      this.form.lat = data.latLng.lat();
      this.form.lng = data.latLng.lng();
    },
    initialPosition() {
      if (this.form.id) {
        this.form.lat = parseFloat(this.form.lat);
        this.form.lng = parseFloat(this.form.lng);
      } else {
        this.form.lat = 33.312805;
        this.form.lng = 44.361488;
      }
    },
    clearForm() {
      this.form = clearObject(this.form);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
#cover {
  img {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
